//-------------------
// call sheet method
//-------------------
export default function callSheetMethod(vm, sheetRefName, methodName, ...args) {
  if (!vm) {
    console.warn('callSheetMethod: vm is required as first argument')
    return
  }

  const ref = vm.$refs && vm.$refs[sheetRefName]
  if (ref && typeof ref[methodName] === 'function') {
    try {
      return ref[methodName](...args)
    } catch (err) {
      console.warn(`Error calling ${methodName} on ${sheetRefName}:`, err)
    }
  } else {
    console.warn(`Ref or method not available: ${sheetRefName}.${methodName}`)
  }
}
